module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model top-model m-b-15"
  }, [_c('div', {
    staticClass: "top-bar  m-b-20"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/finance'
      }
    }
  }, [_vm._v("财务管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("发票管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "top-content flex"
  }, [_c('div', {
    staticClass: "left-box"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("可索取发票金额")]), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_vm._v("¥ " + _vm._s(_vm.invoiceDetail.invoiceAmount))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('router-link', {
    staticClass: "primary-btn",
    attrs: {
      "to": "/index/finance/invoice/info"
    }
  }, [_vm._v("索取发票")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("温馨提示：请在充值后30个工作日内申请开具发票")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('div', {
    staticClass: "cont-title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('p', [_vm._v("默认抬头：" + _vm._s(_vm.invoiceDetail.invoiceTitle || _vm.hrinfo.companyName))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "12px"
    }
  }, [_vm._v("开具类型：企业增值税普通发票")])])])]), _vm._v(" "), _c('div', {
    staticClass: "com-model list-model"
  }, [_c('div', {
    staticClass: "flex m-b-18"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("发票申请时间")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": "选择时间范围"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.dateTimeRange),
      callback: function($$v) {
        _vm.dateTimeRange = $$v
      },
      expression: "dateTimeRange"
    }
  })], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list
    },
    on: {
      "filter-change": _vm.fileterChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "label": "申请时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoiceTitle",
      "label": "发票抬头"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoiceAmount",
      "label": "发票总额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "发票状态",
      "width": "120",
      "column-key": "status",
      "filters": _vm.statusFilters,
      "filter-placement": "bottom-end"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.status[scope.row.status]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "驳回原因"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    staticStyle: {
      "margin-top": "40px",
      "padding-bottom": "40px"
    },
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [5, 10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab78242a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/invoiceList.vue
// module id = 904
// module chunks = 1